/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function () {
	// Add custom code below this line

	function waitForFunction(functionName, callback, interval = 100) {
		if (typeof window[functionName] === 'function') {
			callback();
		} else {
			setTimeout(() => waitForFunction(functionName, callback, interval), interval);
		}
	}

	// Example usage:
	// Assume 'myAsyncFunction' will be defined later
	waitForFunction('SWGetExpressWishlistId', () => {
		var wishlistid = window.SWGetExpressWishlistId();
		var customerid = window.SWGetCustomerWishlistId();
		var wishlistCount = 0;

		if (!customerid) {
			$.ajax({
				url: "/a/wishlist?type=api&wishlistid=" + wishlistid + "&version=1",
				dataType: "json",
				cache: false,
				success: function (data) {
					wishlistCount = data.count;
					if (data.count > 0) {
						document.querySelectorAll("#Wishlist .header_icon_holder").forEach((iconholder) => {
							iconholder.classList.add('has-wishlist');
						});
					}

				}

			});
		}

		//the above code adapted for customer wishlist (logged in users)
		if (customerid != 0) //check if user is logged in
		{
			$.ajax({
				url: "/a/wishlist?type=api&customerid=" + customerid + "&version=1",
				dataType: "json",
				cache: false,
				success: function (data) {
					wishlistCount = data.count;
					if (data.count > 0) {
						document.querySelectorAll("#Wishlist .header_icon_holder").forEach((iconholder) => {
							iconholder.classList.add('has-wishlist');
						});
					}
				}

			});
		}
	});


	//Resize window dispatch event when the class of the header_wrapper changes
	document.addEventListener('DOMContentLoaded', function () {

		const observer = new MutationObserver((mutationsList) => {
			for (const mutation of mutationsList) {
				if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
					window.dispatchEvent(new Event('resize'));
				}
			}
		});
		const targetElement = document.querySelector('.header__wrapper');
		observer.observe(targetElement, {
			attributes: true,
			attributeFilter: ['class']
		});
	});

	document.addEventListener("DOMContentLoaded", function () {
		const cache = {}; // optional memory cache

		async function getHtmlFromUrl(url) {
			try {
				const response = await fetch(url);
				if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
				return await response.text();
			} catch (error) {
				console.error("Error fetching HTML:", error);
				return null;
			}
		}

		function initLoadMoreButtons() {
			document.querySelectorAll(".load--more__btn").forEach((btn) => {
				btn.addEventListener("click", async function (e) {
					e.preventDefault();
					btn.setAttribute("disabled", "disabled");
					const targetSelector = btn.dataset.target;
					const targetElem = document.querySelector(targetSelector);
					if (!targetElem) return;

					const loadMoreUrl = btn.dataset.loadMoreUrl;
					const parser = new DOMParser();
					const htmlString = await getHtmlFromUrl(loadMoreUrl);
					if (!htmlString) return;

					const doc = parser.parseFromString(htmlString, "text/html");
					const newContent = doc.querySelector(targetSelector).innerHTML;

					// Append new items
					targetElem.insertAdjacentHTML("beforeend", newContent);

					// Update or hide the button
					const nextBtn = doc.querySelector(".load--more__btn");
					if (nextBtn) {
						btn.dataset.loadMoreUrl = nextBtn.dataset.loadMoreUrl;
						btn.removeAttribute("disabled");
					} else {
						btn.parentNode.style.display = "none";
					}

					// Save current HTML in cache (lightweight)
					const currentPage = new URL(loadMoreUrl, location.origin).searchParams.get("page") || 1;
					cache[currentPage] = targetElem.innerHTML;

					// Push state
					history.pushState({
						page: currentPage,
						loadMoreUrl: btn.dataset.loadMoreUrl,
						targetSelector: targetSelector,
						scrollY: window.scrollY

					}, "", `?page=${currentPage}`);
				});
			});
		}

		async function handleRestore(e) {
			const state = e.state;
			console.log(state);

			if (!state) return;

			const {
				page,
				loadMoreUrl,
				targetSelector,
				scrollY
			} = state;
			const targetElem = document.querySelector(targetSelector);
			if (!targetElem) return;


			if (cache[page]) {
				targetElem.innerHTML = cache[page];
			} else {
				if (!state.targetSelector) {
					window.location.reload();
					return;
				}
				const htmlString = await getHtmlFromUrl(`?page=${page}`);
				const parser = new DOMParser();
				const doc = parser.parseFromString(htmlString, "text/html");
				targetElem.innerHTML = doc.querySelector(state.targetSelector).innerHTML;

				setTimeout(() => {
					window.scrollTo({
						top: scrollY || 0,
						behavior: 'instant'
					});
				}, 50);
			}

			// Update button
			const btn = document.querySelector(".load--more__btn");
			if (btn && loadMoreUrl) btn.dataset.loadMoreUrl = loadMoreUrl;

			initLoadMoreButtons();
		}

		// Initialize buttons on first load
		initLoadMoreButtons();

		// Restore state on back/forward
		window.addEventListener("popstate", handleRestore);

		// Ensure proper state setup on first load
		const initialPage = new URL(window.location.href).searchParams.get("page") || 1;
		history.replaceState({ page: initialPage }, "", window.location.href);
	});
})();

function WishlistLoadedCallback() {
	console.log("✅ Wishlist has fully loaded!");

	// Example: run custom logic
	const wishlistItems = document.querySelectorAll('.wishlistbodycontainer .product');
	console.log('Wishlist items count:', wishlistItems.length);

	// Example: Add a custom class or modify layout
	wishlistItems.forEach(item => {
		item.classList.add('wishlist-item--custom');
		const productUrl = item.querySelector(".addsingleproduct").dataset.url;
		const productHandle = productUrl.split("?")[0];

		item.querySelector('.singleremovebutton').addEventListener('click', function (e) {
			if (e) e.preventDefault();
			document.querySelector("body").classList.remove('modal-open');
			RemoveFromSmartWishlist(this.getAttribute('data-productid'), this.getAttribute('data-variantid'));
			this.closest('.col-md-4').remove();

		});
		fetch(`${productHandle}?view=metafields-json`)
			.then(res => res.json())
			.then(data => {
				item.querySelector('.price').innerHTML = data.price_html;
				const taglineElem = document.createElement('span');
				taglineElem.classList.add('product-item__tagline');

				if (data.metafields.custom.custom_tagline) {
					const custom_tagline = data.metafields.custom.custom_tagline;
					taglineElem.innerHTML = custom_tagline;
					item.querySelector(".text .buttons").before(taglineElem);
				}
			});

	});
}


document.addEventListener('instafeedAppLoaded', function () {
	const el = document.querySelector("#insta-feed h2");
	if (!el) return;

	// Get the text content
	const text = el.textContent.trim();

	// Split into words
	const words = text.split(" ");

	if (words.length === 0) return;

	// Replace last word with span
	const lastWord = words.pop();
	el.innerHTML = `<a href="https://www.instagram.com/comerfordcollection" target="_blank">${words.join(" ")} <span class="color-gold freight-font italic">${lastWord}</span></a>`;
});


document.addEventListener('DOMContentLoaded', function () {
	const nav = document.querySelector(".collection__nav");
	let lastScroll = window.scrollY;

	document.addEventListener('scroll', function () {
		let scrollDirection = "up";

		if (window.scrollY > lastScroll)
			scrollDirection = "down";


		lastScroll = window.scrollY;

		const cssTop = Math.round(window.getComputedStyle(nav).top.replace("px", ""));
		const boundingRect = nav.getBoundingClientRect();
		const currentTop = (Math.round(boundingRect.top));

		if (cssTop === currentTop) {
			if (scrollDirection === 'up')
				nav.classList.add('is-hidden');
			else
				nav.classList.remove('is-hidden');

		} else {
			nav.classList.remove('is-hidden');

		}
	});
});
document.addEventListener('DOMContentLoaded', function(){
	const popup = document.querySelector(".popup");
	const btnPopups = document.querySelectorAll(".btn--link--popup");
	btnPopups.forEach(function(btnPopup){
		btnPopup.addEventListener('click', function(e){
          if(e) e.preventDefault();
		  popup.querySelector(".popup-content").innerHTML = `<iframe src="${btnPopup.getAttribute('href')}" width="100%"></iframe>`;
		  popup.classList.add('popup-active');

		});
	});
	
	popup.querySelector(".popup-close").addEventListener('click', function(e){
      if(e) e.preventDefault()
		popup.querySelector(".popup-content").innerHTML = '';
		popup.classList.remove('popup-active');
	});

});